import type { Registry as Services } from '@ember/service';
import { tKey } from 'ember-intl';

export interface ApiErrorDetail {
  code?: string;
  detail: string;
  title?: string;
}

export interface ApiError {
  payload: {
    errors: [ApiErrorDetail, ...ApiErrorDetail[]];
  };
}

export function isApiError(error: unknown): error is ApiError {
  return (
    (error as ApiError)?.payload?.errors?.[0]?.detail !== undefined &&
    (error as ApiError)?.payload?.errors?.[0]?.detail !== null &&
    (error as ApiError)?.payload?.errors?.[0]?.detail !== ''
  );
}

export default function getAPIErrorMessage(
  error: unknown,
  intl: Services['intl'],
): string {
  // Check if the API returned a specific error message
  if (isApiError(error)) {
    const key = error.payload.errors[0].detail;

    if (intl.exists(key)) {
      return intl.t(key);
    }
  }

  return intl.t(tKey('general.error'));
}
